import { ArrowLeft, Plus, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
	IconButton,
	OutlinedTextBlueButton,
} from "src/components/Default/LekUI/Button";
import { ConversationList } from "src/components/GlobalChatbot/ConversationList";

interface ChatbotHistoryScreenProps {
	activeConversationId: string | null;
	onSelect: (conversationId: string) => void;
	onDeleted: (conversationId: string) => void;
	onBack: () => void;
	onNewConversation: () => void;
	onClose: () => void;
}

export const ChatbotHistoryScreen = ({
	activeConversationId,
	onSelect,
	onDeleted,
	onBack,
	onNewConversation,
	onClose,
}: ChatbotHistoryScreenProps) => {
	const { t } = useTranslation();

	return (
		<>
			<div className="chatbot-header">
				<IconButton
					data-test-id="global-chatbot-history-back-button"
					onClick={onBack}
				>
					<ArrowLeft className="icon-normal" />
				</IconButton>
				<span className="size-16 flex-1 m-0">
					{t("globalChatbot.history.title", "Historia pytań")}
				</span>
				<OutlinedTextBlueButton
					data-test-id="global-chatbot-history-new-button"
					startIcon={<Plus className="icon-small" />}
					onClick={onNewConversation}
				>
					{t("globalChatbot.new", "Nowa")}
				</OutlinedTextBlueButton>
				<IconButton
					data-test-id="global-chatbot-close-button"
					onClick={onClose}
				>
					<X className="icon-normal" />
				</IconButton>
			</div>
			<ConversationList
				activeConversationId={activeConversationId}
				onSelect={onSelect}
				onDeleted={onDeleted}
			/>
		</>
	);
};
